// GraphQL mutations for user operations

export const UPDATE_USER = /* GraphQL */ `
  mutation UpdateUser($profile: UserInput!) {
    updateUser(profile: $profile) {
      id
      email
      firstName
      lastName
      nickname
      pictureUrl
      birthDate
      address
      phoneNumber
      locale
      zone
      lastSeenAt
      createdAt
    }
  }
`;

// Keep UPDATE_USER_PROFILE as alias for backward compatibility
export const UPDATE_USER_PROFILE = UPDATE_USER;

// Specialized mutation for updating only lastSeenAt
export const UPDATE_LAST_SEEN = /* GraphQL */ `
  mutation UpdateLastSeen($profile: UserInput!) {
    updateUser(profile: $profile) {
      id
      email
      firstName
      lastName
      nickname
      pictureUrl
      birthDate
      address
      phoneNumber
      locale
      zone
      lastSeenAt
      createdAt
    }
  }
`;

